<template>
  <div class="messages">
    <div v-if="currentReport && medicalReport" class="messages__container">
      <div class="messages__header">
        <div class="messages__title">
          <h4 class="">
            Zgłoszenie <code>{{ medicalReport.medicalCase.shortId || "" }}</code>
          </h4>
          <p class="messages__header-subtitle">
            przez {{ medicalReport.author.fullName }}
            <a
              v-if="medicalReport.author.email"
              :href="`mailto:${medicalReport.author.email}`"
              class="messages__btn-contact"
            >
              <img :src="require(`@/assets/svg/envelope.svg`)" alt="" class="header__icon" />
              {{ medicalReport.author.email }}
            </a>
            <a
              v-if="medicalReport.author.phoneNumber"
              :href="`tel:${medicalReport.author.phoneNumber}`"
              class="messages__btn-contact"
            >
              <img :src="require(`@/assets/svg/phone.svg`)" alt="" class="header__icon" />
              {{ medicalReport.author.phoneNumber }}
            </a>
          </p>
        </div>
        <div class="messages__options">
          <Dropdown label="Oznacz jako">
            <button
              class="dropdown__item"
              v-if="['new', 'acknowledged'].includes(medicalReport.state)"
              @click="markmedicalReportAs('ongoing')"
            >
              <IconCommentDots class="dropdown__icon" />
              <span>Oznacz jako rozpoczęte</span>
            </button>
            <button
              class="dropdown__item"
              v-if="medicalReport.state === 'ongoing'"
              @click="markmedicalReportAs('resolved')"
            >
              <IconDone class="dropdown__icon" />
              <span>Oznacz jako zakończone</span>
            </button>

            <hr v-if="medicalReport.state !== 'resolved'" />

            <button
              class="dropdown__item"
              v-if="medicalReport.urgent"
              @click="toggleUrgentStatus(medicalReport.id, medicalReport.urgent)"
            >
              <IconFlag class="dropdown__icon" />
              <span>Oznacz jako zwykłe</span>
            </button>
            <button
              class="dropdown__item"
              v-if="!medicalReport.urgent"
              @click="toggleUrgentStatus(medicalReport.id, medicalReport.urgent)"
            >
              <IconFlag class="dropdown__icon dropdown__icon--red" />
              <span>Oznacz jako priorytetowe</span>
            </button>
          </Dropdown>
          <Dropdown label="Przejdź do">
            <router-link :to="`/zgloszenie/${currentReport}`" class="dropdown__item">
              Szczegóły zgłoszenia
            </router-link>
            <router-link :to="`/zgloszenie/${currentReport}/konsultacja`" class="dropdown__item">
              Konsultacja
            </router-link>
          </Dropdown>
        </div>
      </div>
      <div v-if="activeCaseMessages.length === 0" class="loading">
        <div class="btn spinner spinner--running"></div>
      </div>
      <MessagesContainer
        v-else
        :active-case="activeCaseMessages"
        :current-report="currentReport"
        :user="userData.name"
      />

      <div v-if="currentReport" class="messages__send">
        <transition name="fade-message">
          <div class="messages__info form__row-success" v-if="this.status.success">
            {{ this.status.success }}
          </div>
        </transition>
        <transition name="fade-message">
          <div class="messages__info form__row-error form__row-error--info" v-if="this.status.error">
            {{ this.status.error }}
          </div>
        </transition>

        <div class="messages__field-row">
          <textarea
            v-model="content.message"
            rows="4"
            :placeholder="`Odpowiadasz jako: ${userData.email} \nWpisz wiadomość i wciśnij ENTER aby wysłać...`"
            @keydown="inputHandler"
          ></textarea>
        </div>
      </div>
    </div>

    <ThreadAttachments
      v-if="currentReport && medicalReport"
      :folder-id="medicalReport.medicalCase.folderId"
      :has-access-to-folder="userData.is_admin || userData.is_consultant"
    />
  </div>
</template>

<script>
import axios from "axios";
import Dropdown from "@/components/ui/Dropdown";
import { IconFlag, IconCommentDots, IconDone } from "@/components/ui/icons";
import ThreadAttachments from "@/components/messages/ThreadAttachments";
import MessagesContainer from "@/components/messages/MessagesContainer";
import { mapGetters } from "vuex";

export default {
  name: "Thread",
  components: {
    MessagesContainer,
    ThreadAttachments,

    IconFlag,
    Dropdown,
    IconCommentDots,
    IconDone,
  },
  props: {
    currentReport: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      dropdownOpen: false,
      activeCaseMessages: [],
      latestOpenedReportId: "",
      attachmentsStatus: "",
      medicalReport: null,
      content: {
        message: "",
        attachments: [],
      },
      status: {
        error: "",
        success: "",
      },
      selectedThread: 0,
    };
  },
  computed: mapGetters({
    userData: "getUserData",
    headers: "getSecuredRequestHeader",
    reportList: "getReportList",
  }),
  watch: {
    currentReport() {
      if (!this.currentReport) return;
      this.getMedicalReport(this.currentReport);
    },
  },

  methods: {
    getMedicalReport(id) {
      this.currentReport = id;
      this.$store.commit("saveReportListData", { latestOpenedReportId: id });

      axios
        .get(`${process.env.VUE_APP_API_URL}/medical-report/${id}`, {
          headers: this.headers,
        })
        .then((response) => {
          this.activeCaseMessages = response.data.messages || [];
          this.medicalReport = response.data;
        })
        .then(() => {
          const contentBox = document.querySelector(".messages__content");
          contentBox.scrollTop = contentBox.scrollHeight;
          this.$store.dispatch("refreshUserToken");
        });
    },
    markThreadAsRead(id) {
      axios.put(`${process.env.VUE_APP_API_URL}/medical-report/${id}/read`, {}, { headers: this.headers }).then(() => {
        this.$emit('updateThreadList', { id: id, read: true })
      });
    },
    toggleUrgentStatus(id, isNowUrgent) {
      axios
        .put(
          `${process.env.VUE_APP_API_URL}/medical-report/${id}/${isNowUrgent ? "set-not-urgent" : "set-urgent"}`,
          {},
          { headers: this.headers }
        )
        .then(() => {
          this.$emit('updateThreadList', { id: id, urgent: !isNowUrgent })
          this.medicalReport.urgent = !isNowUrgent;
        });
    },
    inputHandler(e) {
      if (e.keyCode === 13 && !e.shiftKey) {
        e.preventDefault();
        this.sendMessage();
      }
    },
    sendMessage() {
      if (this.content.message.length < 2) {
        this.status.error = "Minimalna długość wiadomości to 2 znaki";
      } else if (this.attachmentsStatus === "selected") {
        this.status.error = 'Aby wysłać załączniki wciśnij przycisk "Rozpocznij przesyłanie"';
      } else if (this.attachmentsStatus === "during") {
        this.status.error = "Zaczekaj aż przesyłanie załączników zostanie zakończone";
      } else {
        this.status.error = "";

        axios({
          method: "post",
          url: `${process.env.VUE_APP_API_URL}/medical-report/${this.currentReport}/message`,
          headers: this.headers,
          data: {
            content: this.content,
            containsAttachments: this.attachmentsStatus === "completed",
          },
        })
          .then(() => {
            this.getMedicalReport(this.currentReport);
            this.status.success = "Wiadomość została wysłana";
            setTimeout(() => {
              this.status.success = "";
            }, 2000);
            this.content.message = this.attachmentsStatus = "";
            this.$store.dispatch("refreshUserToken");
            this.markThreadAsRead(this.currentReport);
          })
          .catch((err) => {
            console.log(err);
            this.status.error = `Wystąpił błąd serwera.`;
          });
      }
    },
    markmedicalReportAs(status) {
      axios
        .put(
          `${process.env.VUE_APP_API_URL}/medical-report/${this.currentReport}/set-${status}`,
          {},
          {
            headers: this.headers,
          }
        )
        .then(() => {
          this.getMedicalReport(this.currentReport);
          this.selectedThread++;
          this.medicalReport.state = status;
        });
    },
  },
  beforeMount() {
    this.getMedicalReport(this.currentReport);
    this.markThreadAsRead(this.currentReport);
  },
};
</script>

<style lang="scss">

.messages {
    $this: &;
    flex: 1;
    display: flex;

    &__container {
        flex: 2;
        display: flex;
        flex-direction: column;
    }

    &__content {
        overflow: auto;
        padding: 20px 10px;
        border-bottom: 2px solid #e1e1e1;
        flex: 1;
        max-height: 60vh;
        &::-webkit-scrollbar {
            width: 5px;
        }
    }
    &__header {
        padding: 5px 15px;
        box-sizing: border-box;
        border-bottom: 2px solid #e1e1e1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        min-height: 80px;

        h4 {
            margin: 0 0 4px;
        }

        &-subtitle {
            font-size: 14px;
            color: #7d7d7d;
            margin: 0;
            display: flex;
            align-items: center;
            gap: 16px;
        }
    }

    &__btn-contact {
        padding: 2px 8px;
        display: inline-flex;
        align-items: center;
        gap: 8px;
        border-radius: 18px;
        color: gray;
        transition: all 150ms;

        &:hover {
            background: #f7f7f7;
            color: black;
        }

        img {
            width: 20px;
            height: 20px;
            object-fit: contain;
            padding: 2px;
        }
    }

    &__send {
        padding: 20px;
        position: relative;
    }
    &__title {
        margin: 0;
    }

    &__options {
        display: flex;
        gap: 8px;
    }

    &__option {
        background: #fbfbfb;
        border: 1px solid #e1e1e1;
        font-size: 14px;
        line-height: 1;
        display: inline-block;
        padding: 10px 16px;
        border-radius: 20px;
        color: #7d7d7d;
        font-weight: bold;
        cursor: pointer;
    }
    &__sidebar {
        box-shadow: inset 10px 0px 10px -10px rgba(0, 0, 0, 0.16);
        &-content {
            padding: 15px;
            max-height: calc(100vh - 150px);
            overflow: auto;
        }
    }
    &__field-row {
        position: relative;
        padding: 15px 0 15px 15px;
        border: 2px solid #e1e1e1;
        border-radius: 15px;
        display: flex;
        textarea {
            border: none;
            padding: 0;
            border-radius: 0;
            flex: 1;
            min-height: unset;
            transition: none;
            resize: vertical;
        }
    }
    &__day {
        border-top: 3px solid #f7f7f7;
        margin: 30px 0;
    }

    &__separator {
        position: relative;
        margin-bottom: 30px;
        span {
            border: 3px solid #f7f7f7;
            background: #fff;
            padding: 6px 16px;
            border-radius: 18px;
            display: inline-block;
            line-height: 1;
            font-weight: bold;
            position: absolute;
            left: 50%;
            top: calc(50% - 3px);
            transform: translate(-50%, -50%);
        }
    }
}

.fade-message-enter-active,
.fade-message-leave-active {
    transition: opacity 0.2s;
}
.fade-message-enter,
.fade-message-leave-to {
    opacity: 0;
}
</style>